export default {
    // GAVL_BACKEND_URL: 'http://127.0.0.1:8000/api',
    // GAVL_BACKEND_URL: 'http://localhost/Pranay/QI%20System%20Projects/gavl-backend/public/api',
    GAVL_BACKEND_URL: 'http://laravelapi.getmepos.com/api',
    ENCRYPTION_KEY: 'gavl_connect_dlilofxx34234lldytuop',
    REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyAdGW-kfbJv3itYZDhKY2CQEG849iq3QgY'
}
